<template>
  <google-map-loader v-bind:map-config="mapConfig" v-bind:api-key="apiKey">
    <template slot-scope="{ google, map }">
      <google-geo-json :google="google" :map="map" :geo-json="geoJson" />
      <!--<google-map-marker v-for="marker in markers"
                         :key="marker.storeid"
                         :marker="marker"
                         :google="google"
                         :map="map">
      </google-map-marker>-->
    </template>
  </google-map-loader>
</template>

<script>
import googleMapLoader from './googleMapLoader.vue';
import googleMapMarker from './googleMapMarker.vue';
import googleGeoJson from './googleGeoJson.vue';
// eslint-disable-next-line import/named
import {
  mapSettings, GOOGLE_MAPS_API_KEY, mapStyle, defaultMapCenter,
} from '../plugins/mapSettings';

export default {
  name: 'googleMap',
  components: {
    googleMapLoader,
    googleMapMarker,
    googleGeoJson,
  },
  props: {
    markers: Array,
    geoJson: Object,
    zoomValue: {
      type: Number,
      default: mapSettings.zoom,
    },
    centerPos: {
      type: Array,
      default() {
        return [defaultMapCenter.lng, defaultMapCenter.lat];
      },
    },
  },
  data() {
    return {
      apiKey: GOOGLE_MAPS_API_KEY,
      /* markers: [
        { id: 'a', position: { lat: 3, lng: 101 }, label: 'A' },
        { id: 'b', position: { lat: 5, lng: 99 }, label: 'B' },
        { id: 'c', position: { lat: 6, lng: 97 }, label: 'C' },
      ], */
    };
  },
  computed: {
    mapConfig() {
      return {
        zoom: this.zoomValue,
        center: { lat: this.centerPos[1], lng: this.centerPos[0] },
        styles: mapStyle,
      };
    },
    /* mapCenter() {
      // eslint-disable-next-line radix,max-len
      // return { lat: this.markers[0].geometry.coordinates[0], lng: this.markers[0].geometry.coordinates[1] };
      return { lat: 47.478325, lng: 19.055449 };
    }, */
  },
  methods: {
    //
  },
};
</script>

<style scoped>

</style>
